/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Typography, Card,
  CardContent,
  Divider,
  FormControl,
  FormControlLabel, Button,
  Dialog,
  MenuItem,
  Box,
  Radio,
  RadioGroup, Stack, InputAdornment,
  IconButton,
  Backdrop
} from "@mui/material";
import VisibilityIcon from "../../../../../../assets/icon-view-on.png";
import VisibilityOffIcon from "../../../../../../assets/icon-view-off.png";
import closeIconPng from "../../../../../../assets/images/Close.png";
import CustomSkeleton from "../../../../../../SharedComponents/skeleton";
import AddPaymentMethodBank from "../../../../../Payments/AddPaymentMethodBank";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useEffect, useState, useMemo, useRef } from "react";
import "./index.scss";
import { useNavigate, useSearchParams } from "react-router-dom";
import AddPaymentMethodNew from "../../../../../Payments/AddpaymentMethodNew";
import {
  BootstrapInput,
  BootstrapSelect,
} from "../../../../../../SharedComponents/inputComponents";
import { useAppDispatch, useAppSelector } from "../../../../../../hooks";
import trashIcon from "../../../../../../assets/images/trash.png";
import errorIcon from "../../../../../../assets/images/icon-alert.svg";
import { DeletePaymentSelected } from "../../utils/DeletePaymentSelected/DeletePaymentSelected";
import {
  getlistOfPaymentMethods, getNonAuthPaymentDetails, onAddEditPaymentMethodLoadingStart,
  onAddEditPaymentMethodLoadingStop, setaddPaymentMethodError, setOpenConfirmCVVModal
} from "../../../../../../SharedContextStore/slices/paymentMethods";
import ApiUrls from "../../../../../../Utils/axr";
import { deletePaymentMethod, updateAuotPayEnroll } from "../../../../../../../../shared/hooks/useFetchPayment";
import useBrightspeedHeaders from "../../../../../../hooks/useBrightspeedHeader";
import { toast } from "react-toastify";
import ToastCustonIcon from "../../../../../../SharedComponents/toastCustomIcons";
import { EC_DW_LOGGING_STEPS } from "../../../../../../../../shared/utils/Constants";
import { getquickBillPayPageContent } from "../../../../../../SharedContextStore/slices/contents/qbpContentAem";
import { format as dateFormat } from "date-fns";
import QBPBillPending from "../../../../NonAuthenticatedQuickBillPay/QBPBillPending";
import ScheduledPayments from "../../../../../../SharedComponents/paymentScheduled";
import { getPaymentHistoryForPA } from "../../../../../../SharedContextStore/slices/paymentHistoryForPA";
import { getNextPaymentDetails } from "../../../../../../SharedContextStore/slices/nextPaymentDetails";
import DeletePaymentMethod from "../../../../../Payments/autoPay/deletePaymentMethod";
import ChangeAutoPaymentMethodNew from "../../../../../Payments/autoPay/changeAutoPaymentMethodNew";
import {
  setSinglePaymentloader, setDeletepayment,
  setNextPrimaryPaymnetId,
  setNextPrimaryMethod,
  setDefaultPaymentId, setPopupDetails, removeAutopay
} from "../../../../../../SharedContextStore/slices/paymentMethodDetails";
import { maskCreditCardNumber, validateCVVSpeedPay } from "../../../../../../Utils/validations-utils";
import DwLogutil from "../../../../../../Utils/DwLogutil";
import ScrollToTop from "../../../../../../Utils/ScrollToTop";
import { QuickBillPay } from "../../../../../../SharedComponents/contents";
import AutoPayMessageNew from "../../../../../Payments/autoPay/autoPayMessage";
import { useCustomNavigate } from "../../../../../../Utils/navigationUtils";
import { getserviceDetails } from "../../../../../../SharedContextStore/slices/serviceDetails";
import { nonAuthenticQBPGTM, authenticQbpGTM, sendEventGTMLog } from "../../../../../../Utils/googleTags";
import useBrightspeedUser from "../../../../../../hooks/useUser";
import { setGTM_TagTriggerFor } from "../../../../../../SharedContextStore/slices/brightSpeedUserUtils";
import { isNegative, renderCurrency } from "../../../../../../Utils/utils";
import { sendEventLog } from "../../../../../../Utils/app-log";
import { startLoading, stopLoading } from "../../../../../../SharedContextStore/slices/user";



export const SelectPayment = (props: any) => {
  const dispatch = useAppDispatch();
  const email = useAppSelector(
    (state) => state?.nonAuthPaymentArrangement?.nonAuthEmailId
  );
  const paymentMethodResponse = useAppSelector(
    (state) => state.paymentMethods?.paymentMethods
  );
  const paymentMethodResponseLoading = useAppSelector(
    (state) => state.paymentMethods?.loading
  );

  type Flags = {
    serviceApiflag: boolean;
    historyApiflag: boolean;
    upcomingPaymentFlag: boolean;
    lstOfPaymentFlag: boolean;
  };

  const flags = useRef<Flags>({
    serviceApiflag: false,
    historyApiflag: false,
    upcomingPaymentFlag: false,
    lstOfPaymentFlag: false,
  });

  const setFlag = (flagName: keyof Flags, value: boolean) => {
    flags.current[flagName] = value;
  };

  const { customNavigate } = useCustomNavigate();

  const {
    nextPrimaryPaymnetId,
    defaultPayId,
    deletePaymentDetails,
    nextPrimaryMethod,
  } = useAppSelector((state) => state?.paymentMethodDetails);
  const companyName: any = useAppSelector((state) => state?.user.companyName);
  const QBP_CONTENT_2: any = QuickBillPay();

  const { autoPaymentMethodForEdit, openAutoPayConfirmCVVModal } = useAppSelector(
    (state) => state.paymentMethods
  );
  const navigation = useNavigate();
  const [searchParams] = useSearchParams();
  const dataInstallments = useAppSelector((state) => state.paymentHistoryForPA?.paymentHistory?.treatment);
  let paymentInstallments = dataInstallments?.length ? dataInstallments[0]?.installment : [];
  const pendingInstalments = paymentInstallments?.filter((installment: any) => installment.status.toLowerCase() !== 'paid');
  paymentInstallments = pendingInstalments?.length ? paymentInstallments : []
  const dataPaymentMethods = useAppSelector(state => state?.paymentMethods?.paymentMethods?.creditcard)

  /** Set State */
  const [amountValue, setAmountValue] = useState<any>('0.00');
  const [agreementChecked, setagreementChecked] = useState<boolean>(false);
  const termsCheckboxRef = useRef<HTMLInputElement>(null);
  const selectedCardRef = useRef<HTMLSelectElement>(null);
  const [convenienceFeeSms, setConvienceSms] = useState<boolean>(false);
  const [selectedCard, setSelectedCard] = useState<string>(
    "Select payment method"
  );
  const [openPaymentNew, setPaymentMethodIsOpen] = useState<boolean>(false);
  const [openPaymentLink, setPaymentLinkIsOpen] = useState<boolean>(false);
  const [showBankAccount, setShowBankAccount] = useState<boolean>(false);
  const [showCreditCard, setShowCreditCard] = useState<boolean>(false);
  const [showDeleteModalBankpay, setshowDeleteModalBankPay] =
    useState<boolean>(false);
  const [showDeleteModalCreditPay, setshowDeleteModalCreditPay] =
    useState<boolean>(false);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  const [selectedInfoCardForEdit, setInfoCardForEdit] = useState<any>({});
  const [showPass, setShowPass] = useState(false);
  const [selectedValueCredit, setSelectedValueCredit] = useState<any>("");
  const [selectedValueBank, setSelectedValueBank] = useState<any>("");
  const [selectedTypeCard, setSelectedTypeCard] = useState<any>(null);
  const [openPaymantFailModal, setOpenPaymantFailModal] =
    useState(false); /* On Add/edit Payment API Fail Show Poup  */
  const [cardCvv, setCardCvv] = useState<any>("");
  const [submitForm, setSubmitForm] = useState<any>(null);
  const [showUnAuthNoBillModal, setShowUnAuthNoBillModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [disableAutopay, setDisableAutopay] = useState<boolean>(false);
  const [chosenPaymentMethod, setChosenPaymentMethod] = useState<any>({});
  const [backToStep1, setBackToStep1] = useState(false)
  const [isCvvFailed, setIsCvvFailed] = useState(false)
  const [isACHPrePay, setIsACHPrePay] = useState(true);
  const {
    nextPaymentDetails,
    loading,
    error,
  } = useAppSelector((state) => state?.nextPaymentDetails || {});
    const nonAuthPaymentDetails = useAppSelector((state) =>state.paymentMethods?.nonAuthPaymentDetails);
  const nonAuthPaymentDetailsLoading = useAppSelector((state) =>state.paymentMethods?.nonAuthPaymentDetailsLoading);
  const { dueDate, nextPayment } = nextPaymentDetails || {};
  const duePayment = nextPayment?.split('$').pop();

  const user = useAppSelector((state) => state.user.data);
  // const userCompanyName = useAppSelector((state) => state?.user?.companyName);
  const headers = useBrightspeedHeaders();
  const userCompanyName = headers.siteId;
  const sessionId = useAppSelector((state) => state?.user?.sessionId);

  const paymentHistoryForPA = useAppSelector((state) => state.paymentHistoryForPA)
  const isAutoPayEnrolled = useAppSelector((state) => state?.planDetails?.isAutoPayEnrolled);
  const { serviceDetails: servicePlan, loading: servicePlanLoading } = useAppSelector((state) => state.serviceDetails);
  const { addPaymentMethodError } = useAppSelector((state) => state?.paymentMethods);
  const isUnAuthQbp = props.isUnAuthQbp;
  const originUrl = sessionStorage.getItem('originUrl') || ''

  const payMethods = () => {

    const methods = paymentMethodResponse?.creditcard;
    const defaultId = paymentMethodResponse?.defaultPaymentMethodId;

    if (!methods && !defaultId) return {};

    const defaultMethod = methods.filter((method: any) => method.id === defaultId)[0];
    const defaultPaymentType = defaultMethod?.paymentType?.toUpperCase();

    const bankAccounts = methods
      .filter((method: any) => (
        method.paymentType?.toUpperCase() === "ACH"
        && method.id !== defaultId /**Remove default payment from list */
      ))
      .sort((a: { type: string }, b: any) => {/**Sort Alphbet ASC to get Checking & then Savings */
        if (a.type < b.type) return -1;
        if (a.type > b.type) return 1;
        return 0;
      });

    const creditcards = methods.filter(
      (method: any) => (
        ["CREDITCARD", "CARD", "ATM"]?.includes(method?.paymentType?.toUpperCase())
        && method.id !== defaultId /**Remove default payment from list */
      )
    );

    /**Add Primary method to first item in the final list */
    if (defaultPaymentType?.toUpperCase() === "ACH") {
      bankAccounts.unshift(defaultMethod);
    }
    if (["CREDITCARD", "CARD", "ATM"]?.includes(defaultPaymentType)) {
      creditcards.unshift(defaultMethod);
    }

    return {
      defaultPaymentMethodId: defaultId,
      bankAccounts,
      creditcards,
    }
  }
  const listOfPayMethods = payMethods();

  const {
    unauthQBP_login_success_sendEventLog,
    unauthqbp_stepped_in,
    qbp_cancel_step1,
    qbp_select_bank_continue_step2,
    qbp_select_credit_continue_step2,
    qbp_delete_bank_cta,
    qbp_delete_cc_cta,
    qbp_cvv_validation_success,
    qbp_cvv_validation_failed
  } = EC_DW_LOGGING_STEPS

  const dwLogDefaults = {
    headers,
    sessionId,
    email: user?.email,
    companyName: userCompanyName,
  }

  const {
    can_GTM_Tag_Trigger,
    GTM_Tag_Triggered_For,
    accountType,
    accountStatus,
    accountTenure,
    isUserHaveAutoPay,
    isUserHavePaperlessBilling,
    currentAmountDue,
    billDueDate,
    lastInvoiceAmount,
    lastBillDate,
    userCurrentInternet_plan_speed,
    voice,
    userStateCode,
    userWire_center,
    isPostPaidFiberUser
  } = useBrightspeedUser();

  useEffect(() => {
    if (
      isUnAuthQbp && can_GTM_Tag_Trigger && GTM_Tag_Triggered_For !== user?.billingAccountNumber && servicePlan
    ) {
      nonAuthenticQBPGTM({
        companyName: headers?.siteId?.toLowerCase() || "",
        accountType,
        accountTenure,
        accountStatus,
        autoPay: isUserHaveAutoPay,
        paperlessBilling: isUserHavePaperlessBilling,
        currentAmountDue,
        billDueDate,
        lastInvoiceAmount,
        lastBillDate,
        internet_plan_speed: userCurrentInternet_plan_speed,
        stateCode: userStateCode,
        wireCenter: userWire_center,
        voice,
        flowType: 'Non authentic qbp flow attempted'
      });

      dispatch(setGTM_TagTriggerFor(user?.billingAccountNumber));
    }
  }, [can_GTM_Tag_Trigger, user, servicePlan]);

  useEffect(() => {
    if (!isUnAuthQbp && can_GTM_Tag_Trigger) {
      authenticQbpGTM({
        flowType: "Authentic qbp flow attempted",
        companyName: headers?.siteId?.toLowerCase() || ""
      })

      dispatch(setGTM_TagTriggerFor(user?.billingAccountNumber));
    }
  }, [can_GTM_Tag_Trigger, user]);

  useEffect(() => {
    if (user?.billingType === "postpaid") {
      setIsACHPrePay(false);
    }
  }, [user])

  const getServiceDetailAsync = async (
    billingNumber: any,
    serviceAddrId: any
  ) => {
    await dispatch(
      getserviceDetails({ billingAccountNumber: billingNumber, serviceAddrId })
    );
  };

  useEffect(() => {
    const addressId = searchParams.get('addressId');
    if (user?.billingAccountNumber && addressId && !servicePlan && !servicePlanLoading && !flags?.current?.serviceApiflag) {
      setFlag("serviceApiflag", true)
      getServiceDetailAsync(user?.billingAccountNumber, addressId)
    }
  }, [user, servicePlan, servicePlanLoading, flags?.current?.serviceApiflag])

  useEffect(() => {
    if (!isUnAuthQbp) return;
    if (!originUrl) { return customNavigate('/login'); }
    // if(!email) return customNavigate(originUrl);
  }, []);

  useEffect(() => {
    if (user?.billingType?.toLowerCase() === "postpaid" && !paymentHistoryForPA.fetched && !flags?.current?.historyApiflag) {
      setFlag("historyApiflag", true)
      dispatch(getPaymentHistoryForPA(user?.billingAccountNumber))
    }
  }, [user, flags?.current?.historyApiflag])

  useEffect(() => {
    if (user && !nextPaymentDetails && !flags?.current?.upcomingPaymentFlag) {
      setFlag("upcomingPaymentFlag", true)
      getNextPayment();
    }

    // New param in Upcoming payments API for No Bill Modal - Non Auth flow
    if (isUnAuthQbp && nextPaymentDetails && nextPaymentDetails?.invoiceGenerated === false) {
      // if( !(nextPaymentDetails?.nextPayment || nextPaymentDetails?.dueDate) ){
      DwLogutil({ stepName: EC_DW_LOGGING_STEPS.unauthqbp_LP_bill_pending });
      setShowUnAuthNoBillModal(true)
      // }
    }
  }, [nextPaymentDetails, flags?.current?.upcomingPaymentFlag]);

  useEffect(() => {
    if(headers?.['access-token']){
      dispatch(getNonAuthPaymentDetails({listofpayment: true, upcoming: true, paymentHistory: true, fetchPlan: false}))
    }
   }, [headers?.['access-token']]);

  const getNextPayment = async () => {
    if ((!nextPaymentDetails || Object.keys(nextPaymentDetails).length === 0) && !loading)
      await dispatch(getNextPaymentDetails(user?.billingAccountNumber));
  };

  const getListOfPaymentMethodsFromApi = async (
    isInitialCall: Boolean = false
  ) => {
    if (props.chosenPayMethod) return;
  user?.billingAccountNumber &&  await dispatch(getlistOfPaymentMethods(user?.billingAccountNumber));
  };

  useEffect(() => {
    if (user?.billingAccountNumber && !flags?.current?.lstOfPaymentFlag) {
      setFlag("lstOfPaymentFlag", true)
      if ((!paymentMethodResponse || Object.keys(paymentMethodResponse).length === 0) && !paymentMethodResponseLoading) {
        getListOfPaymentMethodsFromApi()
      }
    }
  }, [user, flags?.current?.lstOfPaymentFlag])

  useEffect(() => {
    if (selectedCard === 'Bank Account' && listOfPayMethods && listOfPayMethods?.bankAccounts?.length > 0) {
      setSelectedTypeCard(listOfPayMethods?.bankAccounts[0]);
      setSelectedValueBank(listOfPayMethods?.bankAccounts[0]?.id);
    }
    if (selectedCard === 'Credit Card' && listOfPayMethods && listOfPayMethods?.creditcards?.length > 0) {
      setSelectedTypeCard(listOfPayMethods?.creditcards[0]);
      setSelectedValueCredit(listOfPayMethods?.creditcards[0]?.id);
    }
  }, [paymentMethodResponse])

  useEffect(() => {
    const due = (!duePayment || isNegative(duePayment)) ? '0.00' : duePayment;
    setAmountValue(due);
  }, [duePayment]);

  useEffect(() => {
    if (props.chosenPayMethod) {
      if (selectedCard === 'Bank Account') {
        setSelectedTypeCard(props.editItem);
        setSelectedValueBank(props.editItem?.id);
      }
      if (selectedCard === 'Credit Card') {
        setSelectedTypeCard(props.editItem);
        setSelectedValueCredit(props.editItem?.id);
      }
    }
  }, [props.chosenPayMethod])


  /** Called - IF input is a Number */
  const formattingAmountDollar = (event: any) => {
    // Check if the field is currently focused
    const isFocused = event.currentTarget === document.activeElement;
    // Remove non-numeric characters
    const inputValue = event.target.value.replace(/[^0-9.]/g, "");
    // Format to USD currency with 2 decimal places
    const formattedValue = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(parseFloat(inputValue));
    // Update the state with the formatted value if not focused
    setAmountValue(isFocused ? inputValue : formattedValue);
  };

  const [showDisconnectedBalanceDueError, setShowDisconnectedBalanceDueError] = useState(false);
  const isDisconnectedUser = ["INACTIVE", "IN-ACTIVE", "PENDING", "PENDING DISCONNECT", "CANCELLED"]?.includes(user?.currentStatus?.toUpperCase());
  let PA_Flow = false;
  if (typeof paymentInstallments?.length === 'number' && paymentInstallments.length > 0) {
    PA_Flow = true;
  }

  /** called - IF input is cleared */
  const handleFormatandPopulate = (event: any) => {
    const amount = Number(amountValue);
    const ShowError = isDisconnectedUser && (Number(amountValue || 0) > Number(duePayment || 0));
    if (amount) {
      if (!(PA_Flow)) {
        setShowDisconnectedBalanceDueError(ShowError);
      }
      setAmountValue(Number(amountValue || 0)?.toFixed(2))
    } else {
      const due = (!duePayment || isNegative(duePayment)) ? '0.00' : duePayment;
      setAmountValue(due);
      setShowDisconnectedBalanceDueError(false);
    }
  };

  useEffect(() => {
    if (isUnAuthQbp && isDisconnectedUser && !(PA_Flow)) {
      DwLogutil({ stepName: EC_DW_LOGGING_STEPS.unauthqbp_DisconnctedUser_loggedin });
      sendEventLog(EC_DW_LOGGING_STEPS.unauthqbp_DisconnctedUser_loggedin, {
        unauthqbp_DisconnctedUser_loggedin: EC_DW_LOGGING_STEPS.unauthqbp_DisconnctedUser_loggedin
      })
      sendEventGTMLog(EC_DW_LOGGING_STEPS.qbp_DisconnctedUser_loggedin,companyName);
    }
    if (props.QBP_ON && isDisconnectedUser && !(PA_Flow)) {
      DwLogutil({ stepName: EC_DW_LOGGING_STEPS.qbp_DisconnctedUser_loggedin });
      sendEventLog(EC_DW_LOGGING_STEPS.qbp_DisconnctedUser_loggedin, {
        qbp_DisconnctedUser_loggedin: EC_DW_LOGGING_STEPS.qbp_DisconnctedUser_loggedin
      });
      sendEventGTMLog(EC_DW_LOGGING_STEPS.qbp_DisconnctedUser_loggedin,companyName);
    }
  }, [isDisconnectedUser])

  /**DEPENDING OF THE SELECTION OF THE CARD, WE RENDER THE CORRESPONDED LINK */
  const handleSelectChange = (e: any) => {
    const selectedValue = e.target ? e.target.value : e; //e exist from Back link from Next page flow
    switch (selectedValue) {
      case "Select payment method":
        setPaymentLinkIsOpen(false);
        setShowCreditCard(false);
        setShowBankAccount(false);
        setConvienceSms(false);
        setSelectedValueBank(false);
        setSelectedValueCredit(false);
        setSelectedTypeCard(null);
        setPaymentMethodIsOpen(false);
        break;
      case "Bank Account":
        setShowBankAccount(true);
        setShowCreditCard(false);
        setSelectedCard(selectedValue);
        setConvienceSms(false);
        setPaymentLinkIsOpen(true);
        setSelectedValueCredit(false);
        setSelectedTypeCard(null);
        if (listOfPayMethods?.bankAccounts?.length) {
          if (e?.target?.value) {
            setSelectedValueBank(listOfPayMethods?.bankAccounts[0]?.id);
            setSelectedTypeCard(listOfPayMethods?.bankAccounts[0]);
          } else {
            setSelectedValueBank(props?.editItem?.id);
            setSelectedTypeCard(props?.editItem);
          }
        }
        // if (isUnAuthQbp) setPaymentMethodIsOpen(true);
        break;
      case "Credit Card":
        setShowCreditCard(true);
        setShowBankAccount(false);
        setSelectedCard(selectedValue);
        setConvienceSms(true);
        setPaymentLinkIsOpen(true);
        setSelectedValueBank(false);
        setSelectedTypeCard(null);
        if (listOfPayMethods?.creditcards?.length) {
          if (e?.target?.value) {
            setSelectedValueCredit(listOfPayMethods?.creditcards[0]?.id);
            setSelectedTypeCard(listOfPayMethods?.creditcards[0]);
          } else {
            setSelectedValueCredit(props?.editItem?.id);
            setSelectedTypeCard(props?.editItem);
          }
        }
        // if (isUnAuthQbp) setPaymentMethodIsOpen(true);
        break;
      default:
        setPaymentMethodIsOpen(false);
        break;
    }
    setSelectedCard(selectedValue);
    setSubmitForm(false);
  };

  //**Navigate to view payment page */
  const cancelQuickBillPay = () => {
    if (isUnAuthQbp) return customNavigate("/non-auth-quick-bill-pay");

    DwLogutil({
      ...dwLogDefaults,
      stepName: qbp_cancel_step1,
      flowType: user?.currentStatus
    });

    return navigation("/my-bills/view-payments");
  };

  /**handle render to step 2 from saved payment*/
  const activeStep2 = () => {
    props.activeStep2(true, selectedCard, selectedTypeCard, amountValue);
  };
  const handleCloseDeleteModal = (response: any) => {
    setshowDeleteModalCreditPay(response);
    setshowDeleteModalBankPay(response);
  };

  useEffect(() => {
    if (props.chosenPayMethod) {
      setBackToStep1(true); // used only to Retain Amount
      setagreementChecked(true)
    }
  }, []);

  useEffect(() => {
    // getQBPContentsCall();
    if (!QBP_CONTENT_2) {
      dispatch(getquickBillPayPageContent());
    }
  }, []);

  useEffect(() => {
    const due = props.currentAmount
    if (backToStep1 && due && !isNaN(due)) {
      setAmountValue(Number(due || 0)?.toFixed(2) ?? '0:00');
    }
  }, [backToStep1])

  useEffect(() => {
    if (!paymentInstallments?.length) return;

    if (paymentInstallments?.length === 1) {
      setAmountValue(paymentInstallments[0]?.status === 'Pending' ? paymentInstallments[0]?.amount : '0.00')
    }

    if (paymentInstallments?.length > 1) {
      const totalBalance = paymentInstallments
        .filter((installment: { status: string }) => installment?.status === 'Pending')
        .reduce((accum: number, curr: { amount: string }) => accum + Number(curr?.amount || 0), 0);
      setAmountValue(totalBalance.toFixed(2))
    }
  }, [paymentInstallments])


  useMemo(
    () => props.chosenPayMethod && handleSelectChange(props.chosenPayMethod),
    [props.chosenPayMethod]
  );
  useMemo(() => {
    if (props.openEditChosenPayMethod) {
      setShowEditModal(true);
      setInfoCardForEdit(props.editItem);
      setSelectedValueBank(props.editItem?.id);
      setSelectedValueCredit(props.editItem?.id);
    }
  }, [props.openEditChosenPayMethod]);

  
// Build a stable list of IDs for aria-describedby on the select
const selectDescribedByIds = useMemo(() => {
  const ids: string[] = ['required'];

  // Include convenience fee info when it is rendered
  if (convenienceFeeSms) {
    ids.push('convenienceFee-error');
  }

  // Include field error when the form has been submitted and the select is invalid
  const isSelectInvalid =
    submitForm &&
    (
      selectedCard === 'Select payment method' ||
      (selectedCard === 'Bank Account' && !selectedValueBank) ||
      (selectedCard === 'Credit Card' && !selectedValueCredit)
    );

  if (isSelectInvalid) {
    ids.push('payment-error');
  }

  return ids.join(' ');
}, [convenienceFeeSms, submitForm, selectedCard, selectedValueBank, selectedValueCredit]);

  const qbpAgreeAndContinue = async () => {
    setSubmitForm(true);
    if (selectedCard === "Select payment method") {
      let errorField: Element | any = selectedCardRef?.current?.querySelector('input,[tabindex]:not([tabindex="-1"])');
      errorField?.focus?.();
      return;
    } else if (selectedCard === "Credit Card" && (!cardCvv || cardCvv.length < 3)) {
      document.getElementById("cardCvv")?.focus();
      return;
    } else if (!agreementChecked) {
      requestAnimationFrame(() => termsCheckboxRef.current?.focus());
      return
    }
    if (!selectedTypeCard) return;
    if (selectedCard === "Credit Card" && !cardCvv) return;
    if (selectedCard === "Credit Card" && cardCvv?.length < 3) return;

    // Choosing Bank as payments
    if (selectedCard === 'Bank Account') {
      DwLogutil({ stepName: qbp_select_bank_continue_step2, flowType: user?.currentStatus });
      return activeStep2();
    }

    // Choosing Credit Card as payments
    dispatch(setSinglePaymentloader(true))

    const dataParams = {
      cvv: cardCvv,
      expirationDate: `${selectedTypeCard?.expirationMonth?.toLocaleString("en", {
        useGrouping: false,
        minimumIntegerDigits: 2,
      })}/${selectedTypeCard?.expirationYear}`,
      ApiUrls: ApiUrls.updatePaymentMethodUrl_QA,
      cardId: selectedTypeCard?.id,
      headers: headers,
      accountHolderName: selectedTypeCard?.accountHolderInfo?.accountHolderName,
      banNumber: user?.billingAccountNumber,
      billingType: user?.billingType,
      email: user?.email
    }

    try {
      const response = await validateCVVSpeedPay(dataParams);

      if (response && response.status === 200) {
        DwLogutil({ stepName: EC_DW_LOGGING_STEPS.qbp_cvv_validation_success, flowType: user?.currentStatus });
        setIsCvvFailed(false)
        dispatch(setSinglePaymentloader(false))

        DwLogutil({
          ...dwLogDefaults,
          stepName: selectedCard === "Credit Card" ? qbp_select_credit_continue_step2 : qbp_select_bank_continue_step2,
          flowType: user?.currentStatus
        });

        if (!agreementChecked) return;
        return activeStep2();
      } else {
        dispatch(
          setPopupDetails({
            popupName: "apiFailed",
            selectedCard: null,
          }))
        dispatch(setOpenConfirmCVVModal(true));
        dispatch(setSinglePaymentloader(false))

        setIsCvvFailed(true)
        DwLogutil({ stepName: EC_DW_LOGGING_STEPS.qbp_cvv_validation_failed, error: 'Response without 200', flowType: user?.currentStatus });
      }
    } catch (error: any) {
      dispatch(setSinglePaymentloader(false))
      dispatch(
        setPopupDetails({
          popupName: "apiFailed",
          selectedCard: null,
        }))
      // dispatch(setOpenConfirmCVVModal(true));

      setIsCvvFailed(true)
      DwLogutil({ stepName: EC_DW_LOGGING_STEPS.qbp_cvv_validation_failed, error: error?.exception?.message, flowType: user?.currentStatus });
    }
  };

  const unAuthQbpAgreeAndContinue = () => {
    setSelectedCard("Select payment method");
    setConvienceSms(false);
    return activeStep2();
  };

  const makeDefaultPaymentForCTL = async (showSuccessPopup: boolean = true) => {
    try {
      const payload = {
        baseline: {
          siteId: headers?.siteId?.toLowerCase(),
        },
        paymentAuthId: nextPrimaryMethod?.id,
        creditAccount: user?.billingAccountNumber,
        emailAddress: user?.email,
        paymentChannelKind: "Web",
        debitName: `${user?.firstName} ${user?.lastName}`,
        paymentType: nextPrimaryMethod?.paymentType?.toUpperCase() === "ACH" ? "ACH" : "card",
      };

      dispatch(setSinglePaymentloader(true));
      const response = await updateAuotPayEnroll(
        {
          "": `${ApiUrls.update_autopay}`,
        },
        payload,
        headers
      );
      if (response?.status === 200 && response?.data?.status?.toLowerCase() === "active") {

        if (nextPrimaryMethod?.id) {
          dispatch(setDefaultPaymentId(nextPrimaryMethod?.id));
        }
        getListOfPaymentMethodsFromApi();
        DwLogutil({
          ...dwLogDefaults,
          stepName: EC_DW_LOGGING_STEPS.update_PPM_sucess
        });
        dispatch(setSinglePaymentloader(false));
      } else {
        DwLogutil({
          ...dwLogDefaults,
          stepName: EC_DW_LOGGING_STEPS.update_PPM_fail,
          error: "Error"
        });
        dispatch(setSinglePaymentloader(false));
        // DwLogutil({headers, sessionId: user?.sessionId || sessionStorage?.getItem("sessionId"), email: user?.email, companyName: userCompanyName, stepName:EC_DW_LOGGING_STEPS.update_PPM_fail,error:"Fail"});
      }
    } catch (error: any) {
      DwLogutil({
        ...dwLogDefaults,
        stepName: EC_DW_LOGGING_STEPS.update_PPM_fail,
        error: "Error"
      });
      dispatch(setSinglePaymentloader(false));

      // DwLogutil({headers, sessionId: user?.sessionId || sessionStorage?.getItem("sessionId"), email: user?.email, companyName: userCompanyName, stepName:EC_DW_LOGGING_STEPS.update_PPM_fail,error:"Fail"});
    }
  };

  const onDeleteSuccess = async () => {
    try {
      if (deletePaymentDetails?.id) {
        dispatch(onAddEditPaymentMethodLoadingStart());
        const key = ApiUrls.deletePaymentMethodUrl_QA || "";
        const obj = { [key]: `${deletePaymentDetails?.id}?ban=${user?.billingAccountNumber}` };
        await deletePaymentMethod(
        obj,
          headers
        );

        if (deletePaymentDetails?.id === defaultPayId && isAutoPayEnrolled && nextPrimaryMethod) {
          makeDefaultPaymentForCTL(false);
        }

        getListOfPaymentMethodsFromApi();
        setOpenDeleteModal(false);
        dispatch(setDeletepayment(null));
        dispatch(
          setNextPrimaryPaymnetId(
            deletePaymentDetails?.id === defaultPayId
              ? nextPrimaryPaymnetId
              : defaultPayId
          )
        );
        dispatch(
          setDefaultPaymentId(
            deletePaymentDetails?.id === defaultPayId
              ? nextPrimaryPaymnetId
              : defaultPayId
          )
        );
        DwLogutil({
          ...dwLogDefaults,
          stepName: EC_DW_LOGGING_STEPS.deleted_payment_method
        });
        toast.success(
          QBP_CONTENT_2?.entry.paymentMethodSection?.deletePaymentMethodSection?.payment_deleted,
          {
            icon: <ToastCustonIcon type="success" />,
          }
        );
        dispatch(onAddEditPaymentMethodLoadingStop());
      }
    } catch (error: any) {
      console.error(error);
      dispatch(onAddEditPaymentMethodLoadingStop());
      setOpenDeleteModal(false);
      DwLogutil({
        ...dwLogDefaults,
        stepName: EC_DW_LOGGING_STEPS.deleted_payment_method,
        error: error?.response?.data?.message || "Error",
      });

      toast.error(error?.response?.data?.exception?.message || "Something went wrong", {
        icon: <ToastCustonIcon type="error" />,
      });
    }
  };

  const removePaymentMethodPopupClose = (closePopupFlag: boolean) => {
    if (closePopupFlag) {
      dispatch(setNextPrimaryPaymnetId(defaultPayId));
      dispatch(setNextPrimaryMethod(null));
    }
    setOpenDeleteModal(false);
  }

  const disableAutopayCallBack = (flag: string) => {
    if (flag === 'disableAutoPaySuccess') {
      // call remove autopay
      dispatch(removeAutopay(user?.billingAccountNumber));
      DwLogutil({
        ...dwLogDefaults,
        stepName: EC_DW_LOGGING_STEPS.AP_remove_sucess
      });
      DwLogutil({
        ...dwLogDefaults,
        stepName: `${isPostPaidFiberUser ? 'PPF' : ''} ${EC_DW_LOGGING_STEPS.Autopay_unenroll_successfully}`
      });
      sendEventLog(EC_DW_LOGGING_STEPS.AP_remove_sucess, {
        AP_remove_sucess: EC_DW_LOGGING_STEPS.AP_remove_sucess
      });
      sendEventGTMLog(EC_DW_LOGGING_STEPS.AP_remove_sucess, headers?.siteId || companyName);
      // delete payment method
      dispatch(setDeletepayment(chosenPaymentMethod?.method))
      dispatch(
        setPopupDetails(null)
      );
      setDisableAutopay(false);
      onDeleteSuccess()
    }

    if (flag === 'disableAutoPayCancel') {
      setDisableAutopay(false);
    }
  }

  const handleDelete = ({ method, type }: any) => {
    const {
      defaultPaymentMethodId,
      creditcard
    } = paymentMethodResponse;
    dispatch(setDefaultPaymentId(defaultPaymentMethodId));

    const isDefaultMethod = method?.id === defaultPaymentMethodId;

    dispatch(setDeletepayment(method))

    if (isAutoPayEnrolled) {
      if (!isDefaultMethod) {
        return type === 'bank' ? setshowDeleteModalBankPay(true) : setshowDeleteModalCreditPay(true);
      }

      /***  AutoPayEnrolled && Default payment selected */
      if (creditcard.length === 1) {
        dispatch(
          setPopupDetails({ popupName: "disableAutoPay" })
        );
        setChosenPaymentMethod({ method, type })
        setDisableAutopay(true);
        return console.error('Autopay will be disabled')
      }

      if (creditcard.length > 1) {
        setOpenDeleteModal(true); //Delete modal - list's other available methods

        dispatch(
          setNextPrimaryPaymnetId(
            listOfPayMethods?.creditcards?.length >= 1
              ? listOfPayMethods?.creditcards[0].id
              : listOfPayMethods?.bankAccounts[1].id
          )
        );
        dispatch(
          setNextPrimaryMethod((
            listOfPayMethods?.creditcards?.length >= 1
              ? listOfPayMethods?.creditcards[0]
              : listOfPayMethods?.bankAccounts[1]
          ))
        );
        return console.error('Set new default method')
      }
    }

    dispatch(setDeletepayment(method));
    DwLogutil({
      ...dwLogDefaults,
      stepName: selectedCard === "Credit Card" ? qbp_delete_bank_cta : qbp_delete_cc_cta
    });
    return type === 'bank' ? setshowDeleteModalBankPay(true) : setshowDeleteModalCreditPay(true);
  }

  const getPaymentMethod = () => {
    if (dataPaymentMethods?.length) return '';

    const { type, creditCardType, cardNumber, bankAccountNumber } = dataPaymentMethods[0] || {};
    if (creditCardType) { return `${creditCardType} ****${cardNumber?.slice(-4)}` }

    return `${type} ****${bankAccountNumber?.slice(-4)}`
  }


  const editItem = ({ e, item, type }: any) => {
    e.preventDefault();
    setInfoCardForEdit(item);
    setShowEditModal(true);
  }

  const deleteItem = ({ e, item, type }: any) => {
    e.preventDefault();
    setInfoCardForEdit(item);
    handleDelete({
      method: item,
      type
    });
  }

  useEffect(() => {
    if (props.isUnAuthQbp && user?.email) {
      DwLogutil({ stepName: unauthqbp_stepped_in })
      sendEventLog(unauthQBP_login_success_sendEventLog, {qbp_success_all: unauthQBP_login_success_sendEventLog})
      // localStorage.setItem("headersSiteId", "ctl");
      // dispatch(
      //   setHeaders({
      //     ...headers,
      //     siteId: "ctl",
      //   })
      // ); 
      sendEventGTMLog(unauthQBP_login_success_sendEventLog, headers?.siteId || companyName);
    }
  }, [])  
  
  useEffect(() => {
    if (submitForm) {
      if (selectedCard === "Select payment method" && selectedCardRef.current) {
        let errorField: Element | any = selectedCardRef?.current?.querySelector('input,[tabindex]:not([tabindex="-1"])');
        errorField?.focus?.();
      } else if (selectedCard === "Credit Card" && (!cardCvv || cardCvv.length < 3)) {
        document.getElementById("cardCvv")?.focus();
      } else if (!agreementChecked) {
        (document.querySelector('input[type="checkbox"]') as HTMLInputElement)?.focus();
      }
    }
  }, [agreementChecked, cardCvv, selectedCard, submitForm]);


  return (
    <Box className="SelectPayment">
      <ScrollToTop top={40} />

      <Card className="AmountInformationCard" role="region" aria-label={
        isUnAuthQbp
          ? paymentInstallments?.length
            ? QBP_CONTENT_2?.entry.qbp_flow?.select_payment_method?.Payment_plan_details
            : QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.general_label
          : paymentInstallments?.length
            ? QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.general_label
            : QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.general_label
      }>

        <CardContent className="billDetails">
          <Typography
            variant="h2"
            color="initial"
            className="TitleStep1"
            sx={{ marginTop: 2 }}
          >
            {
              isUnAuthQbp
                ? paymentInstallments?.length
                  ? QBP_CONTENT_2?.entry.qbp_flow?.select_payment_method?.Payment_plan_details
                  : QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.general_label
                : paymentInstallments?.length
                  ? QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.general_label
                  : QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.general_label
            }
          </Typography>
          <Divider role="presentation" />

          {!isUnAuthQbp && paymentInstallments?.length > 0 && (
            <Typography
              color="initial"
              component="p"
              className="mb-3 pb-3"
            >
              <span className="font-secondary">{QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.subheader}{" "}
                <strong className="font-secondary">{QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.subheader_highlight_label}</strong>
              </span>
            </Typography>
          )}

          {isUnAuthQbp && !paymentInstallments?.length && (
            <Typography
              variant="body1"
              color="initial"
              className="descriptionPaymentMethod mt-8"
            >
              {QBP_CONTENT_2?.entry.qbp_flow?.select_payment_method?.payment_descriptions?.bill_details_title}
            </Typography>
          )}

          {isUnAuthQbp && (
            <Typography
              variant="subtitle1"
              color="initial"
              className="heading mt-8"
            >
              <span>{
                paymentInstallments?.length
                  ? QBP_CONTENT_2?.entry.qbp_flow?.select_payment_method?.payment_descriptions?.account_number
                  : QBP_CONTENT_2?.entry.qbp_flow?.review_payment_details?.onetime_payment_title
              }</span>
              <strong> ****{user?.billingAccountNumber?.slice(-4)}</strong>
            </Typography>
          )}

          {paymentInstallments?.length
            ? <Box className={isUnAuthQbp ? "mt-4 mb-2" : "mb-2"}>
              <ScheduledPayments pageView="quickBilPay-Step1" unAuthQbp={isUnAuthQbp} />
            </Box>
            : <Box
              sx={{
                display: 'flex',
                width: {xs: "343px", sm: "376px"},
                justifyContent: "space-between",
                gap: 2,
              }}
            >
              {/* Right column */}
              <Box
                sx={{ marginRight: '37px' }}>
                <Typography component="label"
                  sx={{ textAlign: "left", marginLeft: 0 }}
                  className="balanceDue"
                >{QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.amount_due_label}</Typography>
                <Typography component="label"
                  className="TotalAmount d-flex"
                  variant="body1"
                  color="initial"
                >
                  {loading || !duePayment ? (
                    <CustomSkeleton numberOfRows={1} height={30} width={"auto"} />
                  ) : (
                    renderCurrency(duePayment)
                  )}
                </Typography>
              </Box>

              {/* Left column */}
              <Box className="Grid" >
                <Typography component="label"
                  sx={{ textAlign: "left" }}
                  className="balanceDue"
                >{QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method
                  ?.due_date_label}</Typography>
                <Typography component="label"
                  className="TotalAmount d-flex"
                  variant="body1"
                  color="initial"
                >
                  {loading || !dueDate ? (
                    <CustomSkeleton numberOfRows={1} height={30} width={"auto"} />
                  ) : (
                    dateFormat(new Date(dueDate), "M/d/yyyy")
                  )}
                </Typography>
              </Box>
            </Box>
          }
          {paymentInstallments?.length > 0 ?
            <Typography className="amountCurrentPaid mb-1" sx={{ textAlign: "left", display: "block" }}
              component="label" htmlFor="amountInput">
              {
                QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method
                  ?.amounttobepaidLabel_PA
              }
            </Typography> :
            <Typography className="amountCurrentPaid mb-1" sx={{ textAlign: "left", display: "block" }}
              component="label" htmlFor="amountInput">
              {
                QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method
                  ?.amounttobepaidLabel
              }
            </Typography>}
          <FormControl className="form-field">
            <BootstrapInput
              className="amountInput"
              id="amountInput"
              onChange={formattingAmountDollar}
              value={`$${amountValue}`}
              onBlur={handleFormatandPopulate}
              disabled={isDisconnectedUser ? duePayment && parseInt(duePayment) === 0 ? true : false : false}
              // inputProps={{ inputMode: "numeric", pattern: "[0-9]*",
              inputProps={{
                "aria-invalid":
                  QBP_CONTENT_2?.entry?.qbp_flow?.review_payment_details?.descriptions?.errorpayment?.required_message && Object.keys(QBP_CONTENT_2?.entry?.qbp_flow?.review_payment_details?.descriptions?.errorpayment?.required_message).includes("amountInput") ? "true" : "false",
                "aria-required": true,
                inputMode: "numeric", pattern: "[0-9]*",
              }}
            />
          </FormControl>
          {!(PA_Flow) && showDisconnectedBalanceDueError &&
            <Box className="errorMsgFormat">
              <span className="inputFiledErrorImg"></span>
              <span className="inputFiledErrorMsg">
                {QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.disconnectedUserError}
              </span>
            </Box>}
          {paymentInstallments?.length > 0 && <Box className="payment-scheduled">
            <Typography className="nonAuthEligibilityModalRequiredMessage mt-4">
              {
                ['visa', 'mastercard', 'discover']?.includes(
                  nextPaymentDetails?.creditCardType?.toLowerCase()
                )
                  ? QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.pa_step1_subscript_card
                  : isUnAuthQbp
                    ? QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.pa_step1_subscript_unauthqbp_bank
                    : QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.pa_step1_subscript_bank
              }
            </Typography>
          </Box>}
        </CardContent>
      </Card>
      <Card className="SelectPaymentGeneralCard" role="region" aria-label={
        isUnAuthQbp
          ? paymentInstallments?.length
            ? QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.general_label
            : QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.choose_your_way_label
          : paymentInstallments?.length
            ? QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.choose_your_way_label
            : QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.choose_your_way_label
      }>
        <CardContent className="paymentMethodDetails">
          <form action="">
            <Typography
              variant="h2"
              color="initial"
              textAlign={"left"}
              className="chooseYourWayLabel"
              id="selectPayMethod"
            >
              {
                isUnAuthQbp
                  ? paymentInstallments?.length
                    ? QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.general_label
                    : QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.choose_your_way_label
                  : paymentInstallments?.length
                    ? QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.choose_your_way_label
                    : QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.choose_your_way_label
              }
            </Typography>

            <Divider role="presentation" />

            <Typography
              className="descriptionPaymentMethod"
              variant="body1"
              color="initial"
              textAlign={"left"}
              sx={{ marginTop: 4 }}
            >
              {
                isUnAuthQbp ?
                  <span className="font-secondary">{QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.subheader}{" "}
                    <strong className="font-secondary">{QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method?.subheader_highlight_label}</strong>
                  </span>
                  :
                  QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method
                    ?.payment_descriptions?.description_payment_method
              }

            </Typography>

            <Typography
              component="label"
              htmlFor="selectedCard"
              // variant="h3"
              id="selectPaymentLabel"
              color="initial"
              className="selectPaymentLabel"
            >
              {" "}
              {
                QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method
                  ?.select_payment_method_label
              }
              *
            </Typography>

            <FormControl className="form-field">
              
              <BootstrapSelect
                className={`dropdownPayment${selectedCard !== "Select payment method" ? " selected" : ""}`}
                sx={{
                  '.MuiSelect-icon': {
                    right:'8px',
                    fontSize: '2.5rem',
                    color:'black'
                  }
                }}
                ref={selectedCardRef}
                labelId="selectPaymentLabel"
                aria-describedby={selectDescribedByIds}
                
                aria-invalid={
                  submitForm &&
                  (
                    selectedCard === "Select payment method" ||
                    (selectedCard === "Bank Account" && !selectedValueBank) ||
                    (selectedCard === "Credit Card" && !selectedValueCredit)
                  )
                }
                aria-errormessage={
                  submitForm &&
                  (
                    selectedCard === "Select payment method" ||
                    (selectedCard === "Bank Account" && !selectedValueBank) ||
                    (selectedCard === "Credit Card" && !selectedValueCredit)
                  )
                    ? "payment-error"
                    : undefined
                }

                label="Select payment method"
                value={selectedCard}
                disabled={isDisconnectedUser ? (duePayment && parseInt(duePayment) === 0 ? true : false) : false}
                onChange={handleSelectChange}
                inputProps={{
                  'aria-required': true
                }}
              >
               <MenuItem
                  value="Select payment method"
                  className="itemsMenuSelect"
                  hidden
                >
                  {
                    QBP_CONTENT_2?.entry.qbp_flow?.select_payment_method
                      ?.select_payment_method_label
                  }
                </MenuItem>
                <MenuItem value="Bank Account" className="itemsMenuSelect" sx={{
                  '&.Mui-selected': {
                    backgroundColor: '#d0e9ec !important', // highlight selected item
                  },
                  '&:focus': {
                    backgroundColor: '#b2ebf2', // highlight on focus
                  },
                }} autoFocus>
                  {
                    QBP_CONTENT_2?.entry.qbp_flow?.select_payment_method
                      ?.Payment_methods_dropdown.bankAccountLabel
                  }
                </MenuItem>
                <MenuItem value="Credit Card" className="itemsMenuSelect" sx={{
                  '&.Mui-selected': {
                    backgroundColor: '#d0e9ec !important', // highlight selected item
                  },
                  '&:focus': {
                    backgroundColor: '#b2ebf2', // highlight on focus
                  },
                }}>
                  {
                    QBP_CONTENT_2?.entry.qbp_flow?.select_payment_method
                      ?.Payment_methods_dropdown.credit_debitcardLabel
                  }
                </MenuItem>
              </BootstrapSelect>
               
              {submitForm
                && (selectedCard === "Select payment method"
                  || (selectedCard === "Bank Account" && !selectedValueBank)
                  || (selectedCard === "Credit Card" && !selectedValueCredit)
                )
                && (
                  <Box sx={{
                    display: "flex",
                    gap: 2
                  }}>
                    <Box className="err-item" id="payment-error">
                      <img
                        className="err-icon"
                        src={errorIcon}
                        alt=""
                      />
                      <span className="errorMessageAgreement">
                        {
                          QBP_CONTENT_2?.entry?.paymentMethodSection
                            ?.addBankAccount?.manageautopay
                            ?.select_payment_method_error
                        }{" "}
                      </span>
                    </Box>
                  </Box>
                )}

              {convenienceFeeSms && (
                <Box className="d-flex" sx={{ width: { sm: "376px" }, mt: "8px!important" }} gap="4px" id="convenienceFee-error" >
                  <span className="convenienceFeeIcon"></span>
                  <Typography className="qbp convenienceFeeDescription text-spacing">
                    {
                      QBP_CONTENT_2?.entry?.qbp_flow?.select_payment_method
                        ?.payment_descriptions?.convenience_fee
                    }
                  </Typography>
                </Box>
              )}

              {listOfPayMethods?.bankAccounts?.length > 0
                //  && !isUnAuthQbp 
                && showBankAccount
                && (
                  <FormControl className="bankWrapper">
                    <RadioGroup
                      name="BankCard"
                      value={selectedValueBank} // Set the value of the RadioGroup to the selected value.
                      onChange={(event) =>
                        setSelectedValueBank(event.target.value)
                      }
                    >
                      {listOfPayMethods.bankAccounts.map(
                        (item: any, index: any, items: string | any[]) => (
                          <div key={index} className= {`payment-methods ${selectedValueBank === item.id ? `selected-payment-details` : ""}`}>
                            <FormControlLabel
                              htmlFor={`popup-card-${index + 1}`}
                              value={item.id} // Assign a unique value to each radio button.
                              checked={selectedValueBank === item.id} // Check if this radio button is selected.
                              control={<Radio className="list-radio" id={`popup-card-${index + 1}`} />}
                              onClick={() => setSelectedTypeCard(item)}
                              className="label-desc"
                              label={`${item.type} **** ${item.bankAccountNumber.slice(12)}`}
                            />
                            <span className="cta-items">
                             {isACHPrePay && <button aria-label={"edit" + item.type + item.bankAccountNumber.slice(12)} role="button"
                                className="qbp-link btnText p-0" onClick={(e) => editItem({ e, item, type: 'bank' })}>
                                edit
                              </button>}

                              {!isUnAuthQbp && (
                                <>
                                  {isACHPrePay && <span className="seperator">|</span>}
                                  <button aria-label={"delete" + item.type + item.bankAccountNumber.slice(12)} role="button"
                                    className="qbp-link btnText p-0" onClick={(e) => deleteItem({ e, item, type: 'bank' })}>
                                    <img src={trashIcon} width={16} alt="" />
                                  </button>
                                </>
                              )}
                            </span>
                          </div>
                        )
                      )}
                    </RadioGroup>
                  </FormControl>
                )}

              {listOfPayMethods?.creditcards?.length > 0
                // && !isUnAuthQbp 
                && showCreditCard
                && (
                  <FormControl className="creditCardWrapper text-spacing">
                    <RadioGroup
                      name="creditCard"
                      value={selectedValueCredit} // Set the value of the RadioGroup to the selected value.
                      onChange={(event) => {
                        setSelectedValueCredit(event.target.value);
                        setSubmitForm(false);
                        setCardCvv("");
                      }}
                    >
                      {listOfPayMethods.creditcards.map(
                        (item: any, index: any, items: string | any[]) => (
                          <div className= {`payment-methods-block ${selectedValueCredit === item.id ? `selected-card-details` : ""}`}>
                            <div key={index} className={`payment-methods textspacing`}>
                              <FormControlLabel
                                htmlFor={`popupcard-${index + 1}`}
                                value={item.id} // Assign a unique value to each radio button.
                                checked={selectedValueCredit === item.id} // Check if this radio button is selected.
                                control={<Radio className="list-radio" id={`popupcard-${index + 1}`} />}
                                onClick={() => setSelectedTypeCard(item)}
                                className="label-desc"
                                label={
                                  `${item.creditCardType?.toLowerCase() ||
                                  item.type?.toLowerCase()
                                  } **** ${item?.cardNumber.slice(12)}`
                                }
                              />
                              <span className="cta-items">
                                <span className='item-expiry'>{`Exp: ${item.expirationMonth?.toLocaleString(
                                  "en",
                                  {
                                    useGrouping: false,
                                    minimumIntegerDigits: 2,
                                  }
                                )}/${item.expirationYear}`}</span>
                                <button aria-label={"edit" + item.creditCardType?.toLowerCase() + item?.cardNumber.slice(12)} role="button" className="qbp-link btnText p-0" onClick={(e) => editItem({ e, item, type: 'credit' })}>
                                  edit
                                </button>

                                {!isUnAuthQbp && (
                                  <>
                                    <span className="seperator">|</span>
                                    <button aria-label={"delete" + item.creditCardType?.toLowerCase() + item?.cardNumber.slice(12)} role="button" className="qbp-link qbp-link btnText p-0" onClick={(e) => deleteItem({ e, item, type: 'credit' })}>
                                      <img src={trashIcon} width={16} alt="" />
                                    </button>
                                  </>
                                )}
                              </span>
                            </div>

                            {(!selectedValueCredit && index === 0) || selectedValueCredit === item.id ? (
                              <Box className={`cardcvv-block`}>
                                <Typography component="label" htmlFor="cardCvv" style={{ display: "block" }}
                                  variant="body1"
                                  className="cardcvv-label"
                                >
                                  {
                                    QBP_CONTENT_2?.entry?.paymentMethodSection
                                      ?.editPaymentMethodSection
                                      ?.credit_card_details?.cvvLabel
                                  }
                                </Typography>
                                <BootstrapInput
                                  id="cardCvv"
                                  aria-describedby="cvv-error"
                                  placeholder={
                                    QBP_CONTENT_2?.entry?.paymentMethodSection
                                      ?.addPaymentMethodSection
                                      ?.credit_card_details?.cvvPlaceholder
                                  }
                                  type={showPass ? "text" : "password"}
                                  autoComplete="new-password"
                                  value={cardCvv}
                                  onChange={(e) => setCardCvv(e.target.value)}
                                  className={
                                    submitForm && (cardCvv?.length < 3 || isCvvFailed)
                                      ? "err-border cardcvv-input"
                                      : "cardcvv-input"
                                  }
                                  inputProps={{
                                    maxLength: 3, minLength: 3,
                                    "aria-required": true
                                  }}

                                  onKeyPress={(e: any) => {
                                    if (!/[0-9]/.test(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  endAdornment={
                                    <InputAdornment
                                      position="end"
                                      className="eyeToggleBtnWrap"
                                      sx={{
                                        padding: "0px",
                                        position: "relative",
                                        marginLeft: "0px"
                                      }}
                                    >
                                      <IconButton
                                        className="togglePwdVisiblebtn"
                                        // role="switch"
                                        aria-label="cvv code"
                                        aria-describedby="eye-toggle-cof"
                                        aria-pressed={showPass}
                                        // aria-checked={showPass}
                                        onClick={() => setShowPass(!showPass)}
                                        onKeyDown={(event) => {
                                          if (event.key === 'Enter' || event.key === ' ') {
                                            event.preventDefault();
                                            setShowPass(!showPass)
                                          }
                                        }}
                                        edge="end"
                                        onMouseDown={(event) =>
                                          event.preventDefault()
                                        }
                                      >
                                        {/* {!showPass ? (
                                        <img
                                          src={VisibilityOffIcon}
                                          alt="VisibilityOffIcon"
                                        />
                                      ) : (
                                        <img
                                          src={VisibilityIcon}
                                          alt="VisibilityIcon"
                                        />
                                      )} */}
                                        {!showPass ? (
                                          <span aria-label="hide cvv code" id="eye-toggle-cof"><img src={VisibilityOffIcon} alt="" /></span>
                                        ) : (
                                          <span aria-label="show cvv code" id="eye-toggle-cof"> <img src={VisibilityIcon} alt="" /></span>
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />
                                {submitForm && cardCvv?.length < 3 ? (
                                  <Box sx={{
                                    display: "flex",
                                    gap: 2
                                  }} id="cvv-error">
                                    <Box className="err-item">
                                      <img
                                        className="err-icon"
                                        src={errorIcon}
                                        alt=""
                                      />
                                      <span className="errorMessageAgreement">
                                        {QBP_CONTENT_2?.entry?.paymentMethodSection?.editPaymentMethodSection?.credit_card_details?.cvvMissingError}
                                      </span>
                                    </Box>
                                  </Box>
                                ) : (
                                  ""
                                )}
                                {submitForm && isCvvFailed && <Dialog
                                  aria-modal="true"
                                  aria-labelledby="scroll-dialog-title"
                                  // aria-describedby="scroll-dialog-description" 
                                  className="addPaymentNew"
                                  sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
                                  open={isCvvFailed}
                                  scroll='body'
                                >
                                  <AutoPayMessageNew
                                    onCallBack={(e: string) => {
                                      // dispatch(setOpenConfirmCVVModal(false));
                                      dispatch(setPopupDetails(null));
                                      setIsCvvFailed(false);
                                    }}
                                  />
                                </Dialog>}
                              </Box>
                            ) : (
                              ""
                            )
                            }
                          </div>
                        )
                      )}
                    </RadioGroup>
                  </FormControl>
                )}

              {/* Add Bank account or Credit card Button link */}
              {openPaymentLink
                //  && !isUnAuthQbp 
                && (
                  <Box
                    style={{ marginTop: 24, maxWidth: 'fit-content' }}
                    component="button"
                    className="modelButton d-flex align-items-center"
                    onClick={(e: any) => {
                      setPaymentMethodIsOpen(true);
                      e.preventDefault();
                    }}>
                    {/* <AddCircleOutlineIcon className="add-icon" /> */}
                    <Typography
                      variant="body1"
                      sx={{ textDecoration: "underline", marginLeft: "4px" }}
                      className="LinkAddCreditCardBankAccount"
                    >
                      {selectedCard === "Credit Card"
                        ? QBP_CONTENT_2?.entry?.paymentMethodSection?.addBankAccount?.manageautopay?.add_payment_card
                        : QBP_CONTENT_2?.entry?.paymentMethodSection?.addBankAccount?.manageautopay?.add_payment_bank
                      }
                    </Typography>
                  </Box>
                )}

              {/* {isUnAuthQbp &&
                openPaymentNew &&
                selectedCard &&
                selectedCard === "Bank Account" && (
                  <AddPaymentMethodBank
                    onClose={() => {
                      setPaymentMethodIsOpen(false);
                      // setSelectedCard('Select payment method');
                      cancelQuickBillPay();
                    }}
                    unAuthQbp={isUnAuthQbp}
                    onAddEditSuccess={unAuthQbpAgreeAndContinue}
                    showApifailPopup={() => setOpenPaymantFailModal(true)}
                    unAuthCardInfo={props.unAuthCardInfo}
                    showTC={true}
                    backToStep1={backToStep1}
                    retainformDataOnRevisit={props.retainformDataOnRevisit}
                    retainformData={props.retainformData}
                  />
                )}

              {isUnAuthQbp &&
                openPaymentNew &&
                selectedCard &&
                selectedCard === "Credit Card" && (
                  <AddPaymentMethodNew
                    onClose={() => {
                      setPaymentMethodIsOpen(false);
                      // setSelectedCard('Select payment method');
                      cancelQuickBillPay();
                    }}
                    unAuthQbp={isUnAuthQbp}
                    onAddEditSuccess={unAuthQbpAgreeAndContinue}
                    showApifailPopup={() => setOpenPaymantFailModal(true)}
                    unAuthCardInfo={props.unAuthCardInfo}
                    showTC={true}
                    retainformDataOnRevisit={props.retainformDataOnRevisit}
                    retainformData={props.retainformData}
                  />
                )} */}

              {
                // ((isUnAuthQbp && !openPaymentNew) || !isUnAuthQbp) && (
                <Typography
                  variant="body2"
                  color="initial"
                  id="agreementTerms"
                  className="BeforeContinueSms text-spacing pe-lg-5"
                >
                  {
                    QBP_CONTENT_2?.entry?.paymentMethodSection?.addBankAccount
                      ?.manageautopay?.add_auto_pay_desc_line3
                  }
                </Typography>
                // )
              }

              {
                // ((isUnAuthQbp && !openPaymentNew) || !isUnAuthQbp) && (
                <div className="termsWrapper">
                  <Box className="termsCheckboxWrapper">
                    <Typography
                      component="span"
                      className="checkBox"
                    >
                      <label className="checkboxMain">

                        <input                        
                          ref={termsCheckboxRef}
                          tabIndex={0}
                          type="checkbox"
                          checked={agreementChecked}
                          aria-checked={agreementChecked}
                          aria-required="true"
                          aria-invalid={submitForm && !agreementChecked ? true : false}
                          aria-errormessage="terms"
                          aria-describedby="terms agreementTerms"
                          onChange={(e) => setagreementChecked(e.target.checked)}
                          disabled={isDisconnectedUser ? duePayment && parseInt(duePayment) === 0 ? true : false : false}
                          style={{ padding: "0 8px 0 0"}}
                        // className={
                        //   submitForm && !agreementChecked
                        //     ? "terms-check checkBoxLabel err-border"
                        //     : "terms-check checkBoxLabel"
                        // }
                        />
                        <Typography className="terms" component="div">
                          {QBP_CONTENT_2?.entry?.paymentMethodSection?.addBankAccount?.manageautopay?.terms_condi_agree}
                          <a aria-label={QBP_CONTENT_2?.entry.qbp_flow?.select_payment_method?.payment_descriptions?.termsconditionsLabel + " opens in new tab"}
                            target="_blank"
                            href={
                              (companyName &&
                                ["CTL", "CENTURY LINK"].includes(companyName.toUpperCase())) ||
                                (user?.billingType &&
                                  (user?.billingType?.toUpperCase() === "POSTPAID"))
                                ? "https://www.speedpay.com/terms/"
                                : "https://www.brightspeed.com/aboutus/legal/consumer/payment-agreement"

                            } rel="noreferrer"
                          >
                            {QBP_CONTENT_2?.entry.qbp_flow?.select_payment_method?.payment_descriptions?.termsconditionsLabel}
                          </a>.*
                        </Typography>
                        <span className={
                          submitForm && !agreementChecked
                            ? "terms-check checkBoxLabel err-border"
                            : "terms-check checkBoxLabel"
                        }></span>
                      </label>
                    </Typography>
                  </Box>

                  {submitForm && !agreementChecked && (
                    <Box sx={{
                      display: "flex",
                      gap: 2
                    }} id="terms">
                      <Box className="err-item">
                        <img
                          className="err-icon"
                          src={errorIcon}
                          alt=""
                        />
                        <span className="errorMessageAgreement">
                          {
                            QBP_CONTENT_2?.entry?.paymentMethodSection
                              ?.addBankAccount?.bank_account_details
                              ?.paymentTermsAndConditionError
                          }{" "}
                        </span>
                      </Box>
                    </Box>
                  )}
                </div>
                // )
              }

              {
                // ((isUnAuthQbp && !openPaymentNew) || !isUnAuthQbp) && (
                <span className="requiredCheckMark" id="required">
                  {QBP_CONTENT_2?.entry.qbp_flow?.required_label}
                </span>
                // )
              }

              {
                // ((isUnAuthQbp && !openPaymentNew) || !isUnAuthQbp) && (
                <Box className="page-cta-qbp">
                  <Button
                    variant="outlined"
                    onClick={cancelQuickBillPay}
                    className="cancel-button"
                  >
                    {
                      QBP_CONTENT_2?.entry.qbp_flow?.select_payment_method
                        ?.buttons_labels?.cancel
                    }
                  </Button>
                  <Button
                    variant="contained"
                    onClick={qbpAgreeAndContinue}
                    data-value={amountValue}
                    disabled={(!(PA_Flow) ? showDisconnectedBalanceDueError : false) || (amountValue && parseInt(amountValue) > 0 ? false : true)}
                    className="continue-button"
                  >
                    {
                      QBP_CONTENT_2?.entry?.paymentMethodSection?.addBankAccount
                        ?.manageautopay?.agree_and_continue
                    }
                  </Button>
                </Box>
                // )
              }
            </FormControl>
          </form>
        </CardContent>
      </Card>
      {/* Disable Autopay Modal if only one payment method with autopay enrolled */}
      {disableAutopay &&
        <Dialog
          open={disableAutopay}
          className="addPaymentNew"
          scroll='body'
        >
          <AutoPayMessageNew
            onCallBack={(chosenPaymentMethod: string) => disableAutopayCallBack(chosenPaymentMethod)}
          />
        </Dialog>
      }

      {/**Manage Delete - Primary Payment set in Autopay */}
      {openDeleteModal &&
        <Dialog
          open={openDeleteModal}
          className="addPaymentNew"
          scroll='body'
          // aria-describedby="scroll-dialog-description"
          aria-labelledby="scroll-dialog-title"
          aria-modal="true"
        >
          <DeletePaymentMethod
            onClose={(closePopupFlag: boolean) => removePaymentMethodPopupClose(closePopupFlag)}
            listOfPayMethods={listOfPayMethods}
            deleteSuccess={onDeleteSuccess}
          />
        </Dialog>
      }

      {/**Manage Delete - Other Payments */}
      <Dialog
        open={showDeleteModalCreditPay || showDeleteModalBankpay}
        className="addPaymentNew"
        //aria-describedby="scroll-dialog-description"
        aria-labelledby="scroll-dialog-title"
        aria-modal="true"
      >
        <DeletePaymentSelected
          infoCard={selectedInfoCardForEdit}
          closeDialog={handleCloseDeleteModal}
          onSuccess={getListOfPaymentMethodsFromApi}
        />
      </Dialog>

      <Dialog open={
        openPaymentNew
        // && !isUnAuthQbp
      } className="addPaymentNew" scroll='body'
        //  aria-describedby="scroll-dialog-description" 
        // id="dialog-title"
        aria-describedby={selectedCard && selectedCard === "Bank Account" ? "Bank account information" : "Card information"}
        onKeyUp={(e) => {
          if (e.keyCode === 27) {
            setPaymentMethodIsOpen(false)
          }
        }}
        onClose={() => setPaymentMethodIsOpen(false)}
        aria-labelledby="scroll-dialog-title">
        {selectedCard && selectedCard === "Bank Account" ? (

          <AddPaymentMethodBank
            onClose={() => setPaymentMethodIsOpen(false)}
            onAddEditSuccess={getListOfPaymentMethodsFromApi}
            fromEditCard={false}
            temrsCondition={false}
            paymentType=""
            showApifailPopup={() => setOpenPaymantFailModal(true)}
            showTC={false}
            QBP_ON={props.QBP_ON}
            unAuthQbp={isUnAuthQbp}
            retainformDataOnRevisit={props.retainformDataOnRevisit}
            retainformData={props.retainformData}
            unAuthCardInfo={props.unAuthCardInfo}
          />
        ) : (
          <AddPaymentMethodNew
            onClose={() => setPaymentMethodIsOpen(false)}
            onAddEditSuccess={getListOfPaymentMethodsFromApi}
            fromEditCard={false}
            QBP_ON={props.QBP_ON}
            unAuthQbp={isUnAuthQbp}
            isAutoPay={false}
            showApifailPopup={() => setOpenPaymantFailModal(true)}
            isPrePay={false}
            showTC={false}
            retainformDataOnRevisit={props.retainformDataOnRevisit}
            retainformData={props.retainformData}
            unAuthCardInfo={props.unAuthCardInfo}
          />
        )}
      </Dialog>

      {/* Failed API Info Message to User */}
      {openPaymantFailModal &&
        <Dialog open={openPaymantFailModal}
          onClose={(event, reason: any) => {
              if (reason === 'backdropClick') {
                  return;
              }
              setOpenPaymantFailModal(false);
          }}
          className="addPaymentNew"
          // aria-describedby="scroll-dialog-description" 
          aria-labelledby="scroll-dialog-title" aria-modal="true">
          <Box className={"addNewPaymentMethod"}>
            <Typography className="modal-title font-primary" component="h2" id="scroll-dialog-title">
              {addPaymentMethodError?.includes("Debit account already exists for this credit account.") ? QBP_CONTENT_2?.entry?.paymentMethodSection?.addBankAccount?.manageautopay?.existing_card_bank_account_header :
              selectedCard === "Bank Account"
                ? ((bankAccountFailTitle) =>
                  `${QBP_CONTENT_2?.entry?.paymentMethodSection?.addBankAccount?.manageautopay?.pay_method_failed_popup_header_bank}`)()
                : ((cardAccountFailTitle) =>
                  `${QBP_CONTENT_2?.entry?.paymentMethodSection?.addBankAccount?.manageautopay?.pay_method_failed_popup_header_card}`)()}
            </Typography>
            <Typography className="modal-description mb-0">
              {addPaymentMethodError?.includes("Debit account already exists for this credit account.") ? QBP_CONTENT_2?.entry?.paymentMethodSection?.addBankAccount?.manageautopay?.existing_card_bank_account_desc :selectedCard === "Bank Account"
                ? ((bankAccountFailDescription) =>
                  `${QBP_CONTENT_2?.entry?.paymentMethodSection?.addBankAccount?.cardorbankvalidationFailure?.bankAccountFailDescription}`)()
                : ((cardAccountFailDescription) =>
                  `${QBP_CONTENT_2?.entry?.paymentMethodSection?.addBankAccount?.cardorbankvalidationFailure?.cardAccountFailDescription}`)()}
            </Typography>
          </Box>
          {
            <Backdrop className="custom-loader-backdrop" open={nonAuthPaymentDetailsLoading}>
              <div className="custom-loader"></div>
            </Backdrop>}
          <Box className="modal-cta">
            <Button
              className="button-alignment"
              variant="contained"
              color="primary"
              onClick={() => {
                dispatch(setaddPaymentMethodError(""));
                setOpenPaymantFailModal(false);
                // isUnAuthQbp && setSelectedCard("Select payment method");
                isUnAuthQbp && setConvienceSms(false);
                isUnAuthQbp && setPaymentMethodIsOpen(false);
              }}
            >
              {((failButtonValue) => addPaymentMethodError?.includes("Debit account already exists for this credit account.") ? QBP_CONTENT_2?.entry?.paymentMethodSection?.addBankAccount?.manageautopay?.existing_card_bank_account_cta :
                `${QBP_CONTENT_2?.entry?.paymentMethodSection?.addBankAccount?.cardorbankvalidationFailure?.failButtonValue}`)()}
            </Button>
          </Box>
          <Stack
            direction="row"
            justifyContent="end"
            className="close-icon-cantainer"
          >
            <Box className="closeIcon">
              <Typography component="button" className="buttonText" onClick={() => {
              dispatch(setaddPaymentMethodError(""));
               setOpenPaymantFailModal(false);
                // isUnAuthQbp && setSelectedCard("Select payment method");
                isUnAuthQbp && setConvienceSms(false);
                isUnAuthQbp && setPaymentMethodIsOpen(false);
              }}>
                <img
                  src={closeIconPng}
                  alt="Close the dialog"
                />
              </Typography>
            </Box>
          </Stack>
        </Dialog>
      }

      {showEditModal &&
        <Dialog open={showEditModal} className="addPaymentNew" scroll='body'
          // aria-describedby="scroll-dialog-description"
          disableEscapeKeyDown={true}
          onKeyUp={(e) => {
            if (e.keyCode === 27) {
              setShowEditModal(false)
            }
          }}
          onClose={() => setShowEditModal(false)}
          aria-labelledby="scroll-dialog-title" aria-modal="true">
          {selectedCard && selectedCard === "Bank Account" ? (
            <AddPaymentMethodBank
              onClose={() => setShowEditModal(false)}
              QBP_ON={props.QBP_ON}
              unAuthQbp={isUnAuthQbp}
              onAddEditSuccess={getListOfPaymentMethodsFromApi}
              fromEditCard={showEditModal}
              temrsCondition={false}
              showApifailPopup={() => setOpenPaymantFailModal(true)}
              bank={{
                id: selectedInfoCardForEdit?.id,
                bankAccountType: selectedInfoCardForEdit?.type,
                accountUserName:
                  selectedInfoCardForEdit?.accountHolderInfo?.accountHolderName,
                routingNumber: selectedInfoCardForEdit?.routingNumber,
                bankAccountNumber: selectedInfoCardForEdit?.bankAccountNumber,
                confirmBankAccountNumber:
                  selectedInfoCardForEdit?.bankAccountNumber,
                isPrimaryPaymentMethod:
                  selectedInfoCardForEdit?.id ===
                  listOfPayMethods.defaultPaymentMethodId,
              }}
              showTC={false}
              retainformDataOnRevisit={props.retainformDataOnRevisit}
              retainformData={props.retainformData}
            />
          ) : (
            <AddPaymentMethodNew
              onClose={() => setShowEditModal(false)}
              onAddEditSuccess={getListOfPaymentMethodsFromApi}
              fromEditCard={showEditModal}
              QBP_ON={props.QBP_ON}
              unAuthQbp={isUnAuthQbp}
              isAutoPay={false}
              showApifailPopup={() => setOpenPaymantFailModal(true)}
              card={{
                cardId: selectedInfoCardForEdit?.id,
                creditCardNumber: selectedInfoCardForEdit?.cardNumber,
                fullName:
                  selectedInfoCardForEdit?.accountHolderInfo?.accountHolderName,
                expiryDate:
                  `${selectedInfoCardForEdit.expirationMonth?.toLocaleString(
                    "en",
                    {
                      useGrouping: false,
                      minimumIntegerDigits: 2,
                    }
                  )}/${selectedInfoCardForEdit.expirationYear}` || "",
                cvv: "",
                address1: selectedInfoCardForEdit?.address1 || "",
                city: selectedInfoCardForEdit?.city || null,
                zipCode:
                  selectedInfoCardForEdit?.accountHolderInfo?.zipCode || "",
                state: selectedInfoCardForEdit?.state || "State",
                isTermsAndCondition: false,
                // isPrimaryPaymentMethod: false
                isPrimaryPaymentMethod:
                  selectedInfoCardForEdit?.id ===
                  listOfPayMethods.defaultPaymentMethodId,
                creditCardType: selectedInfoCardForEdit?.creditCardType,
                paymentMethodKind: selectedInfoCardForEdit?.type
              }}
              isPrePay={false}
              showTC={false}
              retainformDataOnRevisit={props.retainformDataOnRevisit}
              retainformData={props.retainformData}
            />
          )}
        </Dialog>
      }

      {showUnAuthNoBillModal && <Dialog open={showUnAuthNoBillModal}>
        <QBPBillPending onClose={() => customNavigate("/non-auth-quick-bill-pay")} handlePrimary={() => customNavigate("/login")} />
      </Dialog>}

      {openAutoPayConfirmCVVModal &&
        <Dialog open={openAutoPayConfirmCVVModal} scroll='body'
          // aria-describedby="scroll-dialog-description"
          aria-labelledby="scroll-dialog-title" aria-modal="true">
          <ChangeAutoPaymentMethodNew
            onClose={() => {
              dispatch(setOpenConfirmCVVModal(false));
              dispatch(setNextPrimaryPaymnetId(defaultPayId));
            }}
            cardInfo={{
              cardNumber: `**** ${maskCreditCardNumber(
                nextPrimaryMethod?.cardNumber || 0
              )}`,
              expiryDate: `${nextPrimaryMethod?.expirationMonth?.toLocaleString(
                "en-US",
                {
                  minimumIntegerDigits: 2,
                  useGrouping: false,
                }
              )}/${nextPrimaryMethod?.expirationYear}`,
              cvv: "N/A",
              isPrimaryPaymentMethod: nextPrimaryMethod?.id === defaultPayId,
              id: nextPrimaryMethod?.id,
              creditCardType:
                nextPrimaryMethod?.creditCardType?.charAt(0) +
                nextPrimaryMethod?.creditCardType?.slice(1).toLowerCase(),
              cardDetails: nextPrimaryMethod,
            }}
            isPaypal={false}
            resetRadioBtnSelect={() => { }}

            deleteSuccess={() => {
              onDeleteSuccess();
            }}
            apiStatus={(e: string) => {
              //cvvShowMessage(e);
            }}
          />
        </Dialog>
      }
    </Box>
  );
};
